/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbServiceTutelleGridDto } from './FcbServiceTutelleGridDto';
import {
    FcbServiceTutelleGridDtoFromJSON,
    FcbServiceTutelleGridDtoFromJSONTyped,
    FcbServiceTutelleGridDtoToJSON,
} from './FcbServiceTutelleGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbServiceTutelleGridDtoPaginatedResults
 */
export interface FcbServiceTutelleGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbServiceTutelleGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbServiceTutelleGridDto>}
     * @memberof FcbServiceTutelleGridDtoPaginatedResults
     */
    results?: Array<FcbServiceTutelleGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbServiceTutelleGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbServiceTutelleGridDtoPaginatedResults interface.
 */
export function instanceOfFcbServiceTutelleGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbServiceTutelleGridDtoPaginatedResultsFromJSON(json: any): FcbServiceTutelleGridDtoPaginatedResults {
    return FcbServiceTutelleGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbServiceTutelleGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbServiceTutelleGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbServiceTutelleGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbServiceTutelleGridDtoPaginatedResultsToJSON(value?: FcbServiceTutelleGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbServiceTutelleGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

